import { render, staticRenderFns } from "./_filterLabels.vue?vue&type=template&id=438fb2ac&scoped=true&"
import script from "./_filterLabels.vue?vue&type=script&lang=js&"
export * from "./_filterLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438fb2ac",
  null
  
)

export default component.exports